import { format, unwrapFunctionStore } from 'svelte-i18n';

import { integrationsSettingsStore } from '@client/stores/page-settings';

import { GLOBAL_DRIVER_OBJECT } from '@client/enums';

const $format = unwrapFunctionStore(format);

export const savingIntegration = {
  element:
    '#content > div.page > div.page-header > div > div.flex-align--center.row > div.col-3.col-sm-6.col-md-6.text-right > button.btn.btn-primary',
  popover: {
    title: 'Saving your Changes',
    description:
      "Once you've finished making your edits, click the <strong>&quot;Update&quot;</strong> button at the top right of the screen to save your changes.",

    onNextClick: () => {
      const cancelBtn = document.querySelector('button.hide--mobile.me-2.btn.btn-secondary');

      integrationsSettingsStore.subscribe((integrations) => {
        integrations.tours.editHasToured = true;
      })();

      if (cancelBtn) {
        cancelBtn.click();

        GLOBAL_DRIVER_OBJECT.destroy();
      }
    }
  }
};
